import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import {
  PoresIcon,
  WrinklesIcon,
  DarkSpotsIcon,
  DrynessIcon,
  OilinessIcon,
  DullnessIcon,
  ElasticityIcon,
  AcneIcon,
  RednessIcon,
} from 'on_web/assets/iconsList';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import Question from 'on_web/components/shared/Question/Question';
import UserProfileContext from 'on_web/context/userProfileContext';

import { useTranslation } from 'react-i18next';

export default function SkinCareStep1(props) {
  const context = React.useContext(UserProfileContext);

  const [selectedFacialConcerns, setSelectedFacialConcerns] = useState(
    context && context.userMetaData && context.userMetaData.pceFacialConcerns
      ? context.userMetaData.pceFacialConcerns
      : []
  );

  const { t } = useTranslation();

  const onClickNext = () => {
    const userMetadata = context ? context.userMetaData : null;

    if (props.onClickNext && userMetadata) {
      userMetadata.pceFacialConcerns = selectedFacialConcerns;
      props.onClickNext(userMetadata);
    }
  };

  const questions = [
    {
      icon: <PoresIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep1.pores'),
      checked: selectedFacialConcerns.includes('1'),
      value: '1',
    },
    {
      icon: <WrinklesIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep1.wrinkles'),
      checked: selectedFacialConcerns.includes('2'),
      value: '2',
    },
    {
      icon: <DarkSpotsIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep1.darkSpots'),
      checked: selectedFacialConcerns.includes('3'),
      value: '3',
    },
    {
      icon: <DrynessIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep1.dryness'),
      checked: selectedFacialConcerns.includes('4'),
      value: '4',
    },
    {
      icon: <OilinessIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep1.oiliness'),
      checked: selectedFacialConcerns.includes('5'),
      value: '5',
    },
    {
      icon: <DullnessIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep1.dullness'),
      checked: selectedFacialConcerns.includes('6'),
      value: '6',
    },
    {
      icon: <ElasticityIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep1.elasticity'),
      checked: selectedFacialConcerns.includes('7'),
      value: '7',
    },
    {
      icon: <AcneIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep1.acne'),
      checked: selectedFacialConcerns.includes('8'),
      value: '8',
    },
    {
      icon: <RednessIcon height={'66px'} />,
      label: t('pceOnboarding.skinCareSection.skinCareStep1.redness'),
      checked: selectedFacialConcerns.includes('9'),
      value: '9',
    },
  ];

  const onAnswer = (val, checked) => {
    if (checked) {
      setSelectedFacialConcerns([...selectedFacialConcerns, val]);
    } else {
      setSelectedFacialConcerns(selectedFacialConcerns.filter(i => i !== val));
    }
  };

  return (
    <React.Fragment>
      <Header />
      <PceStepProgressIndicator selectedSlideIx={2} firstStep />

      <Question
        sectionTitle={t(
          'pceOnboarding.skinCareSection.skinCareStep1.sectionTitle1'
        )}
        instructionAbove={t(
          'pceOnboarding.skinCareSection.skinCareStep1.facialConcernsInstructions'
        )}
        checkboxSelectionWithIcon={{ items: questions, twoColumns: true }}
        onAnswer={(val, checked) => onAnswer(val, checked)}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={
          selectedFacialConcerns == null || selectedFacialConcerns.length === 0
        }
      />
    </React.Fragment>
  );
}
